export default import.meta.ROLLUP_FILE_URL_dgXo3qaQZyH2Z1xj8H2_ug